<style lang="scss">
  @import "@/assets/scss/vuexy/components/listItem.scss";
  .text-danger {
    color: #EA5455
  }
  .text-warning {
    color: #FF9F43
  }
  .text-success {
    color: #28C76F
  }
  .color-text-blue {
    color: #0cb0f1
  }
</style>
<template>
  <vs-td :data="value">
      <div class="device-info">
          <div class="shadow-drop d-theme-dark-bg cursor-pointer round" v-if="img != undefined">
            <img :class="this.getAlertColor()" :src="getImgUrl(`${img}${this.icon}`)" class="info-icon p-2 block"/>
          </div>
          <div class="device-text-container">
            <span :class="this.color">{{value}}<span>{{unit}}</span></span>
            <span class="subtext-info" :class="classDescription" v-if="deviceType === 'V' || deviceType === 'C'">{{alert}} {{description}}</span>
            <span class="subtext-info" :class="classDescription" v-if="deviceType !== 'V' && deviceType !== 'C'">{{description}} {{alert}} </span>
          </div>
      </div>
  </vs-td>
</template>
<script>

export default {
  props: {
    img: String,
    value: String,
    unit: String,
    description: String,
    classValue: String,
    classDescription: String,
    alertMin: Number,
    warning: Number,
    alertMax: Number,
    deviceType: String
  },
  data () {
    return {
      icon: '',
      color: '',
      alert: ''
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    },
    getAlertColor () {
      this.color = 'text-danger'
      this.icon = '_red'
      if (!this.warning) {
        if (this.value > this.alertMax) {
          this.color = 'text-danger'
          this.icon = '_red'
          this.alert = this.$t('Labels.HighRank')
        } else if (this.value >= this.alertMin && this.value <= this.alertMax) {
          this.color = 'text-success'
          this.icon = '_green'
          this.alert = this.$t('Labels.CorrectRange')
        } else {
          this.color = 'color-text-blue'
          this.icon = '_blue'
          this.alert = this.$t('Labels.LowRange')
        }
      } else {
        if (this.value <= this.alertMin) {
          this.color = 'text-success'
          this.icon = '_green'
          this.alert = (this.deviceType === 'V' ? this.$t('Labels.RiskFree2') : this.$t('Labels.Good'))
        } else if (this.value <= this.warning) {
          this.color = 'text-warning'
          this.icon = '_warning'
          this.alert = (this.deviceType === 'V' ? this.$t('Labels.RiskModerate2') : this.$t('Labels.Bad'))
        } else if (this.value > this.warning) {
          this.color = 'text-danger'
          this.icon = '_red'
          this.alert = (this.deviceType === 'V' ? this.$t('Labels.RiskHight2') : this.$t('Labels.Poor'))
        }
      }
    }
  },
  created () {
    this.getAlertColor()
  }
}
</script>
